<template>
  <layout-content>
    <form-component v-bind="form_data" />
  </layout-content>
</template>

<script>
  import FormComponent from '@pbx/components/time-conditions/form';
  import { TimeConditionService } from '@pbx/services/TimeConditionService';
  import { WorkTimeService } from '@pbx/services/WorkTimeService';

  export default {
    components: { FormComponent },
    data() {
      return {
        form_data: {
          id: null,
          item: null
        }
      };
    },

    created() {
      if (this.$route.name === 'pbx.time-condition.edit') {
        const id = this.$route.params.id;

        /**
         * TODO :: Попросить метод, который отдает инфу вместе
         */
        Promise.all([TimeConditionService.getItem(id), WorkTimeService.getAll(id)])
          .then(([item, work_time]) => {
            const { id } = item;
            this.form_data = { id, item, work_time };
            this.endLoadingPage();
          })
          .catch(e => this.showPageError(e));
      }
    }
  };
</script>
